<template>
  <v-fade-transition v-if="compatibleBrowser" mode="out-in">
    <router-view />
  </v-fade-transition>
  <div v-else> 
    Incompatible browser, please upgrade!
  </div>
</template>

<script>
  export default {
    data: function () {
        return {
          compatibleBrowser: true
        };
    },
    mounted: function () {
        this.compatibleBrowser = (typeof Object['__defineSetter__'] === 'function') && !!String.prototype.includes;
        if (!this.compatibleBrowser) {
             console.log('Incompatible browser, please upgrade!');
             return;
        }
    }
  }
</script>